import { Type } from "class-transformer";
import { FrontendFieldDefinition } from "src/modules/sm-base/models/frontend-field-definition.model";

export class AnonymousSearchConfig {
    @Type(() => FrontendFieldDefinition)
    formFields: FrontendFieldDefinition[];
    caption = "";
    anonymousOnly = true;
}
